package com.essntl.uikit.components.button.referenceCode

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import com.essntl.uikit.components.tooltip.EsTooltip
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography


@Composable
fun EsRefCodeButton(
    referenceCode: String,
    onClicked: () -> Unit = {},
) {
    val clipboardManager = LocalClipboardManager.current
    EsTooltip(
        text = "Copy to clipboard",
    ) {
        Row(
            horizontalArrangement = Arrangement.Start,
            modifier = Modifier
                .clip(RoundedCornerShape(1.spacing))
                .pointerHoverIcon(PointerIcon.Hand).clickable {
                    clipboardManager.setText(
                        AnnotatedString(
                            referenceCode,
                        ),
                    )
                    onClicked()
                }.padding(0.5.spacing),
        ) {
            Text(
                text = "Ref #",
                style = MaterialTheme.esTypography.c1Medium13,
                color = MaterialTheme.esColorScheme.textDisabled,
            )
            Text(
                text = referenceCode,
                style = MaterialTheme.esTypography.c1Medium13,
                color = MaterialTheme.esColorScheme.textTertiary,
            )
        }
    }
}